import { Auth } from 'aws-amplify'

import type { CognitoUser, CognitoUserSession } from 'amazon-cognito-identity-js'

export type UserSession = {
  user?: {
    email: string
    email_verified: boolean
    family_name: string
    given_name: string
    sub: string
    'cognito:groups'?: string[]
  }
  session?: CognitoUserSession
}

export const recoveryCode = async ({ username }: { username: string }) => {
  try {
    return await Auth.forgotPassword(username)
  } catch (error) {
    return null
  }
}

export const completeNewPassword = async ({ user, newPassword }: { user: CognitoUser; newPassword: string }) => {
  return await Auth.completeNewPassword(user, newPassword)
}

export const setPassword = async ({
  username,
  resetCode,
  newPassword,
}: {
  username: string
  resetCode: string
  newPassword: string
}) => {
  return await Auth.forgotPasswordSubmit(username, resetCode, newPassword)
}

export async function updateUserAttributes(firstName: string, lastName: string, email: string) {
  // TODO - Block until email address sync between apps
  return true
  const user = await Auth.currentAuthenticatedUser()
  return Auth.updateUserAttributes(user, {
    email: email,
    given_name: firstName,
    family_name: lastName,
  })
}

export const isAdminUser = (user?: UserSession['user']) => (user?.['cognito:groups'] ?? []).indexOf('fb_sysadmins') > -1
